import React from "react";

function SyncIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.06 15.567c0 6.494 4.708 10.918 9.997 11.834a1.113 1.113 0 01-.38 2.19c-6.21-1.075-11.84-6.31-11.84-14.024 0-3.279 1.491-5.856 3.232-7.814 1.248-1.404 2.675-2.545 3.823-3.418h-3.49a1.067 1.067 0 110-2.133h6.4a1.066 1.066 0 011.066 1.066v6.4a1.067 1.067 0 01-2.133 0V5.73l-.002.004c-1.22.918-2.71 2.042-4 3.495-1.526 1.715-2.673 3.79-2.673 6.338zm23.697.866c0-6.425-4.608-10.822-9.829-11.804a1.11 1.11 0 11.41-2.184C24.47 3.597 29.98 8.802 29.98 16.433c0 3.28-1.492 5.854-3.232 7.814-1.248 1.404-2.675 2.546-3.823 3.418h3.49a1.067 1.067 0 010 2.134h-6.4a1.066 1.066 0 01-1.067-1.067v-6.4a1.067 1.067 0 112.134 0v3.936h.004c1.218-.922 2.71-2.044 3.998-3.499 1.525-1.713 2.673-3.786 2.673-6.336z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default SyncIcon;
